import lodashSortBy from 'lodash/sortBy';

import moment from 'moment';

import { productionStatusSortOrder } from '../constants';
import { SortBy } from '../types';
import { WorkspaceModelFragment } from './__generated__/fragments.generated';

function getModelWithVersions(model: WorkspaceModelFragment) {
  return model.versionCountByStatus.reduce((acc, { count }) => acc + count, 0) > 0;
}

function getModelsWithVersions(models: WorkspaceModelFragment[]) {
  return Object.values(models).filter(getModelWithVersions);
}

function sortModels(models: WorkspaceModelFragment[], sortBy: SortBy) {
  switch (sortBy) {
    case SortBy.RECENTLY_ACTIVE:
      return lodashSortBy(models, (model) => moment(model.lastActivity).valueOf()).reverse();
    case SortBy.PRODUCTION:
      return lodashSortBy(models, [
        (model) => {
          if (!model.primaryVersion) return productionStatusSortOrder.length;
          if (!model.primaryVersion.isPrimary) return productionStatusSortOrder.length - 3.5;

          return productionStatusSortOrder.indexOf(
            model.primaryVersion.currentModelDeploymentStatus.status,
          );
        },
        (model) => -moment(model.lastActivity).valueOf(),
      ]);
    case SortBy.CREATED:
      return lodashSortBy(models, (model) => moment(model.created).valueOf()).reverse();
    default:
      return lodashSortBy(models, (model) => moment(model.lastActivity).valueOf()).reverse();
  }
}

export { getModelWithVersions, getModelsWithVersions, sortModels };
